import { render, staticRenderFns } from "./Portfolio_general.vue?vue&type=template&id=5a5fe59b&scoped=true&"
import script from "./Portfolio_general.vue?vue&type=script&lang=js&"
export * from "./Portfolio_general.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_general.vue?vue&type=style&index=0&id=5a5fe59b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5fe59b",
  null
  
)

export default component.exports